import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import store from './store/store';
import Layout from './components/layout/Layout';
import QuestsPage from './pages/QuestsPage';
import ServicesPage from './pages/ServicesPage';
import MastersPage from './pages/MastersPage';
import LoginPage from './pages/LoginPage';
import AppealsPage from './pages/AppealsPage';
import PrivateRoute from './components/ui/PrivateRoute';

const YANDEX_METRIKA_ID = 112952008;

const theme = createTheme({
  palette: {
    primary: {
      main: '#008869',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

/** SPA route changes are not full page loads — send Metrika hits manually. */
function YandexMetrikaHit() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.ym === 'function') {
      window.ym(
        YANDEX_METRIKA_ID,
        'hit',
        location.pathname + location.search
      );
    }
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <YandexMetrikaHit />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={
              <PrivateRoute>
                <Layout>
                  <QuestsPage />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/services" element={
              <PrivateRoute>
                <Layout>
                  <ServicesPage />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/masters" element={
              <PrivateRoute>
                <Layout>
                  <MastersPage />
                </Layout>
              </PrivateRoute>
            } />
            <Route path="/appeals" element={
              <PrivateRoute>
                <Layout>
                  <AppealsPage />
                </Layout>
              </PrivateRoute>
            } />
          </Routes>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;